export const getTeamsWrapperProps = (props) => {
    return {
        componentPrefix: props.componentPrefix,
        showLeagueInEventCard: props.details.showLeagueInEventCard,
        leagueName: props.details.event.leagueName,
        team1Name: props.details.event.team1name,
        team2Name: props.details.event.team2name,
        onServe: props.details.event.score.additionalScores.onServe,
        sportId: props.details.event.sportId
    };
};
//# sourceMappingURL=getTeamsWrapperProps.js.map